import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycService } from '@app/core/kyc.service';

@NgModule({
    providers: [KycService]
})

export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts